import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { AlertaSimplesDialog } from '../alerta-simples';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-me-postnew',
  templateUrl: './me-postnew.component.html',
  styleUrls: ['./me-postnew.component.css']
})
export class MePostnewComponent implements OnInit, OnDestroy {
  @ViewChild("capfoto") capfoto: ElementRef;
  @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;

  hideCL: boolean = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  canvasRotation: any = 0;
  comentario: any = '';
  showB: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog : MatDialog) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.hideCL = true;
  }

  async obtainCroppedImage(){
    let image = await this.imageCropper.crop();
    this.croppedImage = image.base64;
}

  ngOnDestroy() {
    this.tmaService.eventoFS(false);
  }

  uploadFile($event) {
    console.log($event.target.files[0]); // outputs the first file
  }

  fileChangeEvent(event: any): void {

    this.imageChangedEvent = event;
    if (this.imageChangedEvent.target.files.length == 0) {
      this.croppedImage = '';
      this.showB = false;
      console.log("just clear");
    }
    else {
      this.hideCL = false;
      console.log("teste");
      this.showB = true;
      setTimeout(() => {
        this.capfoto.nativeElement.scrollIntoView();
      }, 500);

    }

  }

  rotacionarImg(): void {
    console.log("girando");
    this.canvasRotation--;

    this.hideCL = false;
    setTimeout(() => {
      this.hideCL = true;
    }, 1500);
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    console.log(this.croppedImage);
    //console.log(this.croppedImage);
  }
  imageLoaded() {
    // show cropper

  }
  cropperReady() {
    // cropper ready
    this.hideCL = true;
    setTimeout(() => {
      this.capfoto.nativeElement.scrollIntoView();
    }, 500);
  }
  loadImageFailed() {
    // show message
    console.log("failed");
    this.hideCL = true;
  }


  salvar() :void{
    this.obtainCroppedImage();

    if(this.croppedImage == ''){
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Você deve inserir uma foto", iconAlerta: 'warning' }
      })

      return;
    }
    if(this.comentario == ''){
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Você deve inserir um texto para publicar essa foto", iconAlerta: 'warning' }
      })

      return;
    }
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      fotoBase: encodeURI(this.croppedImage),
      comentario: this.comentario
   };

   this.hideCL = false;
     this.tmaService.addNovoPost(customParams)
     .subscribe((qDados) =>{
       console.log(qDados);
       this.hideCL = true;
       //após salvar, faz o redirect
       if(qDados['res'] == 'done'){
         this.voltar(); 
       }
       else{
         //erro
       }
     })
  }

  voltar() :void{
    //this.router.navigate(["/me/perfil/editar/" + this.tipoAdd]);
    //this.router.navigate([ '/' + this.route.snapshot.paramMap.get('nomeusuario') + '/' + this.tipoAdd]);
    // this._location.back();

    this.router.navigate(['me/feed']);
  }
}
